// Utilitários de formatação

/**
 * Formata período de MM-YYYY para MM/YYYY
 * @param {string} period - Período no formato MM-YYYY
 * @returns {string} - Período formatado MM/YYYY
 */
export const formatPeriod = (period) => {
  if (!period) return '';
  return period.replace('-', '/');
};

/**
 * Converte período de MM/YYYY para MM-YYYY (para envio à API)
 * @param {string} period - Período no formato MM/YYYY
 * @returns {string} - Período no formato MM-YYYY
 */
export const parsePeriod = (period) => {
  if (!period) return '';
  return period.replace('/', '-');
};

/**
 * Formata número para formato brasileiro
 * @param {number} number - Número a ser formatado
 * @returns {string} - Número formatado
 */
export const formatNumber = (number) => {
  if (!number && number !== 0) return '0';
  return number.toLocaleString('pt-BR');
};

/**
 * Formata data para formato brasileiro
 * @param {string|Date} date - Data a ser formatada
 * @returns {string} - Data formatada DD/MM/YYYY
 */
export const formatDate = (date) => {
  if (!date) return '-';
  const dateObj = typeof date === 'string' ? new Date(date) : date;
  return dateObj.toLocaleDateString('pt-BR');
};

/**
 * Obtém o período atual no formato MM-YYYY
 * @returns {string} - Período atual MM-YYYY
 */
export const getCurrentPeriod = () => {
  const now = new Date();
  const mm = String(now.getMonth() + 1).padStart(2, '0');
  const yyyy = now.getFullYear();
  return `${mm}-${yyyy}`;
};
